<template>
  <RouterLink
      :to="route"
      :class="`btn btn-${type} btn-${size} text-${textSize} ${textColorClass} ${hoverClass ? 'hover:' + hoverClass : ''} font-${fontWeight} ${addClassOption}`"
      :active-class="activeClass"
  >
    {{ text }}
  </RouterLink>
</template>

<script setup lang="ts">
import {RouterLink} from "vue-router";

interface Props {
  route?: string
  type?: 'primary' | 'secondary' | 'outline'  | 'danger'
  size?: 'sm' | 'md' | 'lg'
  text?: string
  textSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  textColorClass?: string
  fontWeight?: 'light' | 'medium' | 'bold'
  activeClass?: string
  hoverClass?: string
  addClassOption?: string
}

withDefaults(defineProps<Props>(), {
  route: '/',
  type: 'primary',
  size: 'sm',
  text: 'Button',
  textSize: 'xs',
  textColorClass: '',
  fontWeight: 'medium',
  activeClass: 'text-primary-600',
  hoverClass: '',
  addClassOption: '',
})
</script>